module.exports = "images/get-inspired-8.webp";